(function () {
  const modal = document.querySelector('[data-contact-request-modal]');
  const pageRoots = Array.from(document.querySelectorAll('[data-contact-request-page]'));
  const storageKey = 'sa-contact-request-draft';

  function getStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function readDraft() {
    const storage = getStorage();
    if (!storage) return null;

    try {
      const raw = storage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeDraft(draft) {
    const storage = getStorage();
    if (!storage) return;

    try {
      storage.setItem(storageKey, JSON.stringify(draft));
    } catch (error) {
      // Ignore storage quota and privacy mode failures.
    }
  }

  function clearDraft() {
    const storage = getStorage();
    if (!storage) return;
    storage.removeItem(storageKey);
  }

  function normalizeValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function humanizeHandle(handle) {
    return normalizeValue(handle).replace(/-/g, ' ');
  }

  function toAbsoluteUrl(url) {
    const value = normalizeValue(url);
    if (!value) return '';

    try {
      return new URL(value, window.location.origin).toString();
    } catch (error) {
      return value;
    }
  }

  function createContext(values) {
    const productHandle = normalizeValue(values.productHandle);
    const productTitle = normalizeValue(values.productTitle) || humanizeHandle(productHandle);
    const variantTitle = normalizeValue(values.variantTitle);

    return {
      productHandle,
      productTitle,
      variantId: normalizeValue(values.variantId),
      variantTitle: variantTitle === 'Default Title' ? '' : variantTitle,
      sku: normalizeValue(values.sku),
      productUrl: toAbsoluteUrl(values.productUrl),
      productImage: toAbsoluteUrl(values.productImage),
      source: normalizeValue(values.source) || 'maatwerk-aanvraag',
    };
  }

  function hasContext(context) {
    return Boolean(context && (context.productTitle || context.productHandle));
  }

  function buildMessage(context) {
    const lines = [
      'Hallo,',
      '',
      'Ik ontvang graag meer informatie en een offerte voor dit maatwerkproduct.',
      '',
      `Product: ${context.productTitle || 'Onbekend product'}`,
    ];

    if (context.variantTitle) lines.push(`Variant: ${context.variantTitle}`);
    if (context.sku) lines.push(`SKU: ${context.sku}`);
    if (context.productUrl) lines.push(`Productlink: ${context.productUrl}`);

    lines.push('', 'Mijn vraag of gewenste uitvoering:');
    return lines.join('\n');
  }

  function getInput(root, name) {
    return root ? root.querySelector(`[data-contact-request-input="${name}"]`) : null;
  }

  function setInputValue(root, name, value) {
    const input = getInput(root, name);
    if (input) input.value = value || '';
  }

  function cacheInitialValues(root) {
    if (!root) return;

    root.querySelectorAll('[data-contact-request-input]').forEach((input) => {
      if (typeof input.dataset.contactRequestInitialValue === 'undefined') {
        input.dataset.contactRequestInitialValue = input.value || '';
      }
    });
  }

  function getInitialValue(input) {
    return input ? input.dataset.contactRequestInitialValue || '' : '';
  }

  function bindSummary(root, context) {
    const summary = root.querySelector('[data-contact-request-summary]');
    if (!summary) return;

    if (!hasContext(context)) {
      summary.hidden = true;
      return;
    }

    summary.hidden = false;

    const productTitle = root.querySelector('[data-contact-request-bind="product-title"]');
    if (productTitle) productTitle.textContent = context.productTitle;

    const variant = root.querySelector('[data-contact-request-bind="variant"]');
    if (variant) {
      variant.textContent = context.variantTitle ? `Variant: ${context.variantTitle}` : '';
      variant.hidden = !context.variantTitle;
    }

    const sku = root.querySelector('[data-contact-request-bind="sku"]');
    if (sku) {
      sku.textContent = context.sku ? `SKU: ${context.sku}` : '';
      sku.hidden = !context.sku;
    }

    const link = root.querySelector('[data-contact-request-bind="link"]');
    if (link) {
      link.href = context.productUrl || '#';
      link.hidden = !context.productUrl;
    }

    const imageWrapper = root.querySelector('[data-contact-request-image-wrapper]');
    const image = root.querySelector('[data-contact-request-bind="image"]');
    if (image && imageWrapper) {
      if (context.productImage) {
        image.src = context.productImage;
        image.alt = context.productTitle || 'Productafbeelding';
        imageWrapper.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        imageWrapper.hidden = true;
      }
    }
  }

  function clearSummary(root) {
    const summary = root.querySelector('[data-contact-request-summary]');
    if (summary) summary.hidden = true;

    const productTitle = root.querySelector('[data-contact-request-bind="product-title"]');
    if (productTitle) productTitle.textContent = '';

    const variant = root.querySelector('[data-contact-request-bind="variant"]');
    if (variant) {
      variant.textContent = '';
      variant.hidden = true;
    }

    const sku = root.querySelector('[data-contact-request-bind="sku"]');
    if (sku) {
      sku.textContent = '';
      sku.hidden = true;
    }

    const link = root.querySelector('[data-contact-request-bind="link"]');
    if (link) {
      link.hidden = true;
      link.setAttribute('href', '#');
    }

    const imageWrapper = root.querySelector('[data-contact-request-image-wrapper]');
    const image = root.querySelector('[data-contact-request-bind="image"]');
    if (imageWrapper) imageWrapper.hidden = true;
    if (image) {
      image.src = image.getAttribute('src') || '';
      image.alt = '';
    }
  }

  function resetRequestRoot(root, options = {}) {
    if (!root) return;

    const defaultSubject = normalizeValue(root.dataset.contactRequestDefaultSubject) || '';
    const defaultSource = normalizeValue(root.dataset.contactRequestDefaultSource) || '';

    clearSummary(root);
    root.dataset.contactRequestContext = '';
    setInputValue(root, 'subject', defaultSubject);
    setInputValue(root, 'product', '');
    setInputValue(root, 'variant', '');
    setInputValue(root, 'sku', '');
    setInputValue(root, 'product-url', '');
    setInputValue(root, 'source', defaultSource);

    const messageInput = getInput(root, 'message');
    if (messageInput && options.resetMessage) {
      messageInput.value = getInitialValue(messageInput);
      messageInput.dataset.contactRequestAutofilled = 'false';
    }

    if (options.resetContactFields) {
      ['name', 'company', 'email', 'phone'].forEach((fieldName) => {
        const input = getInput(root, fieldName);
        if (input) input.value = getInitialValue(input);
      });
    }
  }

  function clearContactRequestUrl() {
    const url = new URL(window.location.href);
    [
      'contact_product',
      'contact_product_title',
      'contact_variant',
      'contact_variant_title',
      'contact_sku',
      'contact_product_url',
      'contact_product_image',
      'contact_source',
    ].forEach((key) => url.searchParams.delete(key));

    url.hash = 'zakelijk-contact';
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash ? `#${url.hash.replace('#', '')}` : ''}`);
  }

  function populateRoot(root, context, options = {}) {
    if (!root || !hasContext(context)) return;

    const defaultSubject = normalizeValue(root.dataset.contactRequestDefaultSubject) || 'Offerteaanvraag maatwerkproduct';
    const defaultSource = normalizeValue(root.dataset.contactRequestDefaultSource) || 'maatwerk-aanvraag';
    const subject = context.productTitle ? `${defaultSubject} - ${context.productTitle}` : defaultSubject;

    bindSummary(root, context);
    setInputValue(root, 'subject', subject);
    setInputValue(root, 'product', context.productTitle);
    setInputValue(root, 'variant', context.variantTitle);
    setInputValue(root, 'sku', context.sku);
    setInputValue(root, 'product-url', context.productUrl);
    setInputValue(root, 'source', context.source || defaultSource);

    const messageInput = getInput(root, 'message');
    if (messageInput && !messageInput.dataset.contactRequestTracked) {
      messageInput.dataset.contactRequestTracked = 'true';
      messageInput.addEventListener('input', () => {
        messageInput.dataset.contactRequestAutofilled = 'false';
      });
    }

    if (messageInput) {
      const shouldOverwrite = options.overwriteMessage === true;
      if (shouldOverwrite || !normalizeValue(messageInput.value)) {
        messageInput.value = buildMessage(context);
        messageInput.dataset.contactRequestAutofilled = 'true';
      }
    }

    root.dataset.contactRequestContext = JSON.stringify(context);
  }

  function collectFields(root) {
    const fieldNames = ['name', 'company', 'email', 'phone', 'message'];
    return fieldNames.reduce((result, fieldName) => {
      const input = getInput(root, fieldName);
      result[fieldName] = input ? input.value : '';
      return result;
    }, {});
  }

  function restoreFields(root, fields, options = {}) {
    if (!root || !fields) return;

    Object.entries(fields).forEach(([fieldName, value]) => {
      const input = getInput(root, fieldName);
      if (!input) return;

      const hasValue = normalizeValue(input.value);
      if (options.force || !hasValue) {
        input.value = value || '';
      }
    });
  }

  function readStoredContext(root) {
    if (!root) return null;

    try {
      return normalizeValue(root.dataset.contactRequestContext)
        ? JSON.parse(root.dataset.contactRequestContext)
        : null;
    } catch (error) {
      return null;
    }
  }

  function setFallbackLink(root, href) {
    const wrapper = root ? root.querySelector('[data-contact-request-fallback]') : null;
    const link = root ? root.querySelector('[data-contact-request-fallback-link]') : null;
    if (!wrapper || !link) return;

    const fallbackHref = normalizeValue(href);
    if (!fallbackHref) {
      wrapper.hidden = true;
      link.removeAttribute('href');
      return;
    }

    link.href = fallbackHref;
    wrapper.hidden = false;
  }

  function createContextFromTrigger(trigger) {
    const { dataset } = trigger;
    return createContext({
      productHandle: dataset.contactRequestProductHandle,
      productTitle: dataset.contactRequestProductTitle,
      variantId: dataset.contactRequestVariantId,
      variantTitle: dataset.contactRequestVariantTitle,
      sku: dataset.contactRequestSku,
      productUrl: dataset.contactRequestProductUrl,
      productImage: dataset.contactRequestProductImage,
      source: dataset.contactRequestSource,
    });
  }

  function createContextFromQuery() {
    const params = new URLSearchParams(window.location.search);
    return createContext({
      productHandle: params.get('contact_product'),
      productTitle: params.get('contact_product_title'),
      variantId: params.get('contact_variant'),
      variantTitle: params.get('contact_variant_title'),
      sku: params.get('contact_sku'),
      productUrl: params.get('contact_product_url'),
      productImage: params.get('contact_product_image'),
      source: params.get('contact_source'),
    });
  }

  function isModifiedClick(event) {
    return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  }

  function openModal(trigger) {
    if (!modal || typeof modal.show !== 'function') return false;

    const context = createContextFromTrigger(trigger);
    if (!hasContext(context)) return false;

    resetRequestRoot(modal, { resetContactFields: true, resetMessage: true });
    populateRoot(modal, context, { overwriteMessage: true });
    setFallbackLink(modal, trigger.getAttribute('href'));
    writeDraft({
      path: window.location.pathname,
      context,
      fields: collectFields(modal),
      submitted: false,
    });
    modal.show(trigger);
    return true;
  }

  if (modal) {
    cacheInitialValues(modal);
    const modalForm = modal.querySelector('form');
    const fallbackLink = modal.querySelector('[data-contact-request-fallback-link]');
    if (modalForm) {
      modalForm.addEventListener('submit', () => {
        const draftContext = readStoredContext(modal);

        writeDraft({
          path: window.location.pathname,
          context: draftContext,
          fields: collectFields(modal),
          submitted: true,
        });
      });
    }

    if (fallbackLink) {
      fallbackLink.addEventListener('click', () => {
        const draftContext = readStoredContext(modal);
        if (!draftContext) return;

        try {
          const destination = new URL(fallbackLink.href, window.location.origin);
          writeDraft({
            path: destination.pathname,
            context: draftContext,
            fields: collectFields(modal),
            submitted: false,
          });
        } catch (error) {
          // Ignore invalid fallback URLs.
        }
      });
    }

    const stateElement = modal.querySelector('[data-contact-request-form-state]');
    const state = stateElement ? stateElement.dataset.contactRequestFormState : 'idle';
    const draft = readDraft();
    if (draft && draft.path === window.location.pathname && draft.submitted && state !== 'idle') {
      if (draft.context) {
        populateRoot(modal, draft.context, { overwriteMessage: false });
      }
      if (state === 'error') {
        restoreFields(modal, draft.fields);
      }
      modal.show();
      if (state === 'success') {
        clearDraft();
      }
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-request-trigger]');
    if (!trigger || isModifiedClick(event)) return;

    if (openModal(trigger)) {
      event.preventDefault();
    }
  });

  const queryContext = createContextFromQuery();
  const pageDraft = readDraft();
  pageRoots.forEach((root) => {
    cacheInitialValues(root);
    const pageState = root.querySelector('[data-contact-request-page-state]')?.dataset.contactRequestPageState || 'idle';
    const hasMatchingDraft = pageDraft && pageDraft.path === window.location.pathname;

    if (hasContext(queryContext)) {
      populateRoot(root, queryContext, { overwriteMessage: false });
      if (hasMatchingDraft) {
        restoreFields(root, pageDraft.fields);
        if (pageState === 'success' || pageState === 'idle') {
          clearDraft();
        }
      }
    } else if (hasMatchingDraft && pageState !== 'idle') {
      if (pageDraft.context) {
        populateRoot(root, pageDraft.context, { overwriteMessage: false });
      }
      restoreFields(root, pageDraft.fields);
      if (pageState === 'success') {
        clearDraft();
      }
    } else if (hasMatchingDraft) {
      clearDraft();
    }
  });

  document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-contact-request-clear]');
    if (!clearButton) return;

    const root = clearButton.closest('[data-contact-request-page], [data-contact-request-modal]');
    if (!root) return;

    event.preventDefault();
    clearDraft();
    resetRequestRoot(root, { resetMessage: true });

    if (root.matches('[data-contact-request-page]')) {
      clearContactRequestUrl();
    }
  });
})();